import React, { useState } from "react";
import { Formik, useFormik } from "formik";
import _ from "lodash";
import "../../styles/eligibility.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../shared/CustomButton";
import { FaFilter, FaUndo } from "react-icons/fa";
import AppButton from "../../../../shared/AppButton";
import CustomFilterInput from "../../../../shared/CustomFilterInput";

function FilterModal({
  refetch,
  eligibilityFilters,
  setEligibilityFilters,
  setIsLoading,
  fromDate,
  toDate,
}) {
  const { t, i18n } = useTranslation();
  const [payers, setPayers] = useState([]);
  const navigate = useNavigate();

  const addData = async (values) => {
    let payload = {
      from_date: values.from_date,
      to_date: values.to_date,
      payer_id: values.payer_id,
      eligibility_id: values.eligibility_id,
      status: values.status,
      patient_name: values.patient_name,
      document_id: values.document_id,
      limit: 10,
      page: 1,
    };
    localStorage.setItem("eligibilityFilterDate", JSON.stringify(payload));
    setIsLoading(true);
    await refetch({
      input: Object.keys(payload).reduce((acc, key) => {
        const value = payload[key];
        if (value !== "" && value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {}),
    });
    setEligibilityFilters(payload);
    setIsLoading(false);
  };

  const handleResetForm = async (values) => {
    let payload = {
      from_date: fromDate,
      to_date: toDate,
      payer_id: "",
      eligibility_id: "",
      status: "",
      patient_name: "",
      document_id: "",
      limit: 10,
      page: 1,
    };
    localStorage.setItem("eligibilityFilterDate", JSON.stringify(payload));
    setIsLoading(true);
    await refetch({
      input: Object.keys(payload).reduce((acc, key) => {
        const value = payload[key];
        if (value !== "" && value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {}),
    });
    setIsLoading(false);
    setEligibilityFilters(payload);
  };

  React.useEffect(() => {
    const payersData = JSON.parse(localStorage.getItem("payersData"));

    if (payersData && payersData.length > 0) {
      setPayers(payersData);
    } else {
      navigate("/dashboard");
    }
  }, []);

  const statuses = [
    // { id: "complete", name: t("Processing Complete") },
    { id: "complete", name: t("Eligible") },
    { id: "error", name: t("Not Eligible") },
  ];

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: {
      from_date: eligibilityFilters?.from_date || fromDate,
      to_date: eligibilityFilters?.to_date || toDate,
      // eligibility_id: eligibilityFilters?.eligibility_id || "",
      payer_id: eligibilityFilters?.payer_id || "",
      patient_name: eligibilityFilters?.patient_name || "",
      document_id: eligibilityFilters?.document_id || "",
      status: eligibilityFilters?.status || "",
    },
    onSubmit: (values, { setSubmitting }) => {
      addData(values);
    },
    onReset: (values, { setSubmitting }) => {
      handleResetForm(values);
    },
  });

  return (
    <div className="w-full">
      <div className="flex flex-col md:flex-row md:flex-wrap md:items-end justify-end gap-2 w-full">
        <CustomFilterInput
          label={t("From Date")}
          name="from_date"
          value={values.from_date}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("From Date")}
          type="date"
          className="w-full md:w-[160px]"
        />
        <CustomFilterInput
          label={t("To Date")}
          name="to_date"
          value={values.to_date}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("To Date")}
          type="date"
          className="w-full md:w-[160px]"
        />
        {/* <CustomFilterInput
          label={t("Eligibility ID")}
          name="eligibility_id"
          value={values.eligibility_id}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Eligibility ID")}
          className="w-full md:w-[160px]"
        /> */}
        <CustomFilterInput
          label={t("Select Payer")}
          name="payer_id"
          value={values.payer_id}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Select Payer")}
          isSelect
          className="w-full md:w-[160px]"
          renderOptions={() =>
            payers.map((category) => (
              <optgroup
                key={category.id}
                label={
                  category?.name_en
                    ? `${category?.name_en} (${category?.license_id})`
                    : ""
                }
              >
                {category?.payers?.map((insurance, idx) => (
                  <option key={`${insurance?.id}-${idx}`} value={insurance?.id}>
                    {insurance?.name_en} ({insurance?.license_id})
                  </option>
                ))}
              </optgroup>
            ))
          }
        />

        <CustomFilterInput
          label={t("Enter Beneficiary Name")}
          name="patient_name"
          value={values.patient_name}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Enter Beneficiary Name")}
          className="w-full md:w-[160px]"
        />
        <CustomFilterInput
          label={t("Document ID")}
          name="document_id"
          value={values.document_id}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Document ID")}
          className="w-full md:w-[160px]"
        />

        <CustomFilterInput
          label={t("Select Status")}
          name="status"
          value={values.status}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Select Status")}
          isSelect
          options={statuses}
          className="w-full md:w-[160px]"
        />

        <div className="flex justify-end gap-2 items-end">
          <AppButton
            title={t("Reset")}
            variant="reset"
            onClick={resetForm}
            startIcon={<FaUndo className="!text-[12px]" />}
          />

          <AppButton
            title={t("Apply Filter")}
            onClick={() => {
              handleSubmit();
            }}
            startIcon={<FaFilter className="!text-[12px]" />}
          />
        </div>
      </div>
    </div>
  );
}

export default FilterModal;
